import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import Modal from 'react-modal'
import UIMessages from 'src/utils/ui-messages'
import Select from 'react-select'
import {
  IProviderProductObject,
  IScheduledRequestedTripsFiltersDTO,
  IServiceListFilterDTO,
  IServiceObject,
  ITripOptimizationResponse,
  IUpdateOptimizedTripsDTO
} from 'src/types'
import moment, { Moment } from 'moment'
import ProgressBarModal from './ProgressBarModal'
import { Datepicker } from '@mobiscroll/react'

interface IRouteOptimizationProps {
  onClose: () => any
  optimizeTripModalIsOpen: boolean
  orgId: string
  products: IProviderProductObject[]
  services: IServiceObject[]
  optimizeRouteResponse: ITripOptimizationResponse | null | undefined
  optimizeTripResponse: ITripOptimizationResponse | null | undefined
  optimizeRoute: (request: IScheduledRequestedTripsFiltersDTO) => Promise<ITripOptimizationResponse>
  optimizeTrip: (request: IUpdateOptimizedTripsDTO) => Promise<ITripOptimizationResponse>
  getScheduledRequestedTrips: (params: IScheduledRequestedTripsFiltersDTO) => Promise<any>
}

interface IRouteOptimizationState {
  optimizeTripModalIsOpen: boolean
  confirmationModalIsOpen: boolean
  routeOptimizationModalIsOpen: boolean
  progressValue: number
  selectedService: string
  selectedProduct: string
  tripDate: Date
  totalVehicle: number
  maxTripPerVehicle: number
  duration: number
  isOptimizeRouteStarting: boolean
  isOptimizeTripLoading: boolean
  isOptimizeTripEnabled: boolean
  optimizeRouteResponse: ITripOptimizationResponse | null | undefined
  optimizeTripResponse: ITripOptimizationResponse | null | undefined
}

export default class RouteOptimization extends React.Component<IRouteOptimizationProps, IRouteOptimizationState> {
  constructor(props: IRouteOptimizationProps) {
    super(props)
    this.state = {
      optimizeTripModalIsOpen: this.props.optimizeTripModalIsOpen,
      confirmationModalIsOpen: false,
      routeOptimizationModalIsOpen: false,
      progressValue: 0,
      selectedService: '',
      selectedProduct: '',
      tripDate: new Date(),
      totalVehicle: 0,
      maxTripPerVehicle: 0,
      isOptimizeRouteStarting: false,
      isOptimizeTripLoading: false,
      isOptimizeTripEnabled: false,
      optimizeRouteResponse: null,
      optimizeTripResponse: null,
      duration: 100000
    }
  }

  public render() {
    const {
      optimizeTripModalIsOpen,
      confirmationModalIsOpen,
      routeOptimizationModalIsOpen,
      tripDate,
      totalVehicle,
      maxTripPerVehicle,
      isOptimizeRouteStarting,
      isOptimizeTripLoading,
      isOptimizeTripEnabled,
      optimizeRouteResponse,
      optimizeTripResponse,
      duration
    } = this.state
    const productOptions = this.props.products.map(prd => ({ label: prd.name, value: prd.id }))
    const servicesOptions = this.props.services.map(svc => ({ label: svc.name, value: svc.id }))

    return (
      <>
        <Modal isOpen={optimizeTripModalIsOpen} className='Modal' ariaHideApp={false}>
          <div className='overlay bg-dark-grey' />
          <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
            <div className='bg-white col-4 p3'>
              {optimizeRouteResponse && (
                <div
                  className={
                    `mt1 mb2 p2 rounded font-white ` + (optimizeRouteResponse.success ? 'bg-green' : 'bg-light-red')
                  }
                >
                  {optimizeRouteResponse.success
                    ? `${optimizeRouteResponse.message} Click Optimize Trips below. Reference Id: ${
                        optimizeRouteResponse.id
                      }`
                    : optimizeRouteResponse.message}
                </div>
              )}
              {optimizeTripResponse && (
                <div
                  className={
                    `mt1 mb2 p2 rounded font-white ` + (optimizeTripResponse.success ? 'bg-green' : 'bg-light-red')
                  }
                >
                  {optimizeTripResponse.success
                    ? `${optimizeTripResponse.message} You may now close this modal or start optimizing again.`
                    : optimizeTripResponse.message}
                </div>
              )}
              <span className='ModalAddTitle weight-300 font-grey2 mb1 h3'>{UIMessages.optimizeTrip.modalTitle}</span>
              <div className='mt2'>
                <label htmlFor='selectService'>Service:</label>
                <Select
                  id='selectService'
                  name='selectService'
                  isClearable={true}
                  isSearchable={true}
                  onChange={this.onServiceChange}
                  options={servicesOptions}
                />
              </div>
              <div className='mt2'>
                <label htmlFor='selectProduct'>Product:</label>
                <Select
                  id='selectProduct'
                  name='selectProduct'
                  isClearable={true}
                  isSearchable={true}
                  onChange={this.onProductChange}
                  options={productOptions}
                />
              </div>
              <div className='flex col-12 mt2 items-center'>
                <div className='col-5'>
                  <label htmlFor='tripDate'>Trip Date:</label>
                </div>
                <div className='col-7'>
                  <Datepicker
                    controls={['calendar']}
                    dateFormat='MM/DD/YYYY'
                    inputProps={{
                      className: 'rounded p1 h4 mt02 border-light-grey4',
                      placeholder: 'Select Trip Date'
                    }}
                    value={moment(tripDate.toISOString())}
                    onChange={({ value }) => this.onTripDateChange(moment(value))}
                  />
                </div>
              </div>
              <div className='flex col-12 mt2 items-center'>
                <div className='col-5'>
                  <label htmlFor='totalVehicle'>Total Vehicle:</label>
                </div>
                <div className='col-7'>
                  <input
                    id='totalVehicle'
                    className='rounded p1 h4 mt02 border-light-grey4'
                    type='number'
                    value={totalVehicle}
                    onChange={this.onTotalVehicle}
                    min={0}
                  />
                </div>
              </div>
              <div className='flex col-12 mt2 items-center'>
                <div className='col-5'>
                  <label htmlFor='maxTripPerVehicle'>Maximum Trip Per Vehicle:</label>
                </div>
                <div className='col-7'>
                  <input
                    id='maxTripPerVehicle'
                    className='rounded p1 h4 mt02 border-light-grey4'
                    type='number'
                    value={maxTripPerVehicle}
                    onChange={this.onMaxTripPerVehicle}
                    min={0}
                  />
                </div>
              </div>

              <div className='flex col-12 mt4'>
                <div className='col-2 left-align'>
                  <button
                    type='button'
                    onClick={() => this.handleConfirmationModal()}
                    className='CancelButton btn bg-white rounded font-light-grey border-light-grey'
                  >
                    {UIMessages.common.cancel}
                  </button>
                </div>
                <div className='col-7 right-align'>
                  {isOptimizeRouteStarting ? (
                    <>
                      <div
                        className='flex bt font-light-grey weight-300'
                        style={{ justifyContent: 'right', marginTop: '8px' }}
                      >
                        <MoonLoader sizeUnit={'px'} size={12} color={'#405264'} loading={true} /> Optimizing Route...
                      </div>
                    </>
                  ) : (
                    <button
                      type='submit'
                      onClick={this.onStartRouteOptimization}
                      className='SubmitButton btn bg-green rounded font-white weight-300'
                    >
                      Start Route Optimization
                    </button>
                  )}
                </div>
                <div className='col-4 right-align'>
                  {isOptimizeTripLoading ? (
                    <>
                      <div
                        className='flex bt font-light-grey weight-300'
                        style={{ justifyContent: 'right', marginTop: '8px' }}
                      >
                        <MoonLoader sizeUnit={'px'} size={12} color={'#405264'} loading={true} /> Optimizing Trip...
                      </div>
                    </>
                  ) : (
                    <button
                      type='submit'
                      onClick={this.onOptimizeTrip}
                      disabled={isOptimizeTripEnabled ? false : true}
                      className={
                        'SubmitButton font-white btn rounded weight-300 ' +
                        (isOptimizeTripEnabled ? 'bg-green' : 'bg-grey cursor--not-allowed')
                      }
                    >
                      Optimize Trips
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal isOpen={confirmationModalIsOpen} className='Modal' ariaHideApp={false}>
          <div className='overlay bg-dark-grey' />
          <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
            <div className='bg-white col-4 p2'>
              <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 mb1 h3'>
                Would you like to close the optimization of trips? If you proceed, you'll have to begin the optimization
                process again.
              </span>
              <div className='mt2'>
                <button
                  type='button'
                  onClick={() => this.handleConfirmationModal()}
                  className='SubmitButton btn bg-green rounded font-white weight-300 mr2'
                >
                  No
                </button>
                <button
                  type='button'
                  onClick={() => this.handleConfirmationModal(true)}
                  className='CancelButton btn bg-grey rounded font-white'
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <ProgressBarModal isOpen={routeOptimizationModalIsOpen} duration={duration} title={'Optimizing Routes...'} />
      </>
    )
  }

  private handleConfirmationModal = (shouldClearFields: boolean = false) => {
    if (shouldClearFields) {
      this.setState(prevState => ({
        optimizeTripModalIsOpen: !prevState.optimizeTripModalIsOpen,
        confirmationModalIsOpen: !prevState.confirmationModalIsOpen,
        selectedService: '',
        selectedProduct: '',
        tripDate: new Date(),
        totalVehicle: 0,
        maxTripPerVehicle: 0,
        isOptimizeRouteStarting: false,
        isOptimizeTripLoading: false,
        isOptimizeTripEnabled: false,
        optimizeRouteResponse: null,
        optimizeTripResponse: null
      }))
      this.props.onClose()
    } else {
      this.setState(prevState => ({ confirmationModalIsOpen: !prevState.confirmationModalIsOpen }))
    }
  }

  private onServiceChange = ({ value }: { label: string; value: string }) => {
    this.setState({ selectedService: value })
  }

  private onProductChange = ({ value }: { label: string; value: string }) => {
    this.setState({ selectedProduct: value })
  }

  private onTripDateChange = (value: Moment) => {
    /**
     * Manually get the time since mobiscroll onChange event does not have the value
     * and to sync with the existing implementation using react-datepicker
     */
    const time = moment()
      .format('HH:mm:ss')
      .split(':')
      .map(value => Number(value))
    const date = moment(value)
      .hour(time[0])
      .minute(time[1])
      .second(time[2])
    this.setState({ tripDate: date.toDate() })
  }

  private onTotalVehicle = (e: any) => {
    this.setState({ totalVehicle: e.target.value })
  }

  private onMaxTripPerVehicle = (e: any) => {
    this.setState({ maxTripPerVehicle: e.target.value })
  }

  private onStartRouteOptimization = async () => {
    const { selectedService, selectedProduct, tripDate, totalVehicle, maxTripPerVehicle } = this.state
    console.log('Start Route Optimization... ')

    const orgId = this.props.orgId
    const date = moment(this.state.tripDate)
    const dto: IServiceListFilterDTO = {
      fromDate: date.startOf('day').toISOString(),
      toDate: date.endOf('day').toISOString(),
      lastStatusIds: '21'
    }

    const optimizeRouteParams = {
      serviceId: selectedService,
      productId: selectedProduct,
      date: tripDate.toUTCString(),
      totalVehicle,
      maximumTripPerVehicle: maxTripPerVehicle,
      orgId: this.props.orgId
    }

    const trips = await this.props.getScheduledRequestedTrips(optimizeRouteParams)

    const roundedToNearestTen = Math.ceil(trips.totalTrips / 10) * 10
    const duration = (roundedToNearestTen / 10) * 5000

    this.setState({
      duration
    })

    setTimeout(() => {
      console.log('STATE DURATION: ' + this.state.duration)
      this.setState({
        isOptimizeRouteStarting: true,
        isOptimizeTripEnabled: false,
        optimizeRouteResponse: null,
        optimizeTripResponse: null,
        routeOptimizationModalIsOpen: true
      })
    }, 250)

    const response = await this.props.optimizeRoute(optimizeRouteParams)

    if (response.success === true) {
      setTimeout(() => {
        this.setState({
          isOptimizeRouteStarting: false,
          isOptimizeTripEnabled: response && response.success ? true : false,
          optimizeRouteResponse: response && response.success ? this.props.optimizeRouteResponse : null,
          routeOptimizationModalIsOpen: false
        })
      }, duration + 500)
    } else {
      this.setState({
        isOptimizeRouteStarting: false,
        isOptimizeTripEnabled: response && response.success ? true : false,
        optimizeRouteResponse: response && response.success ? this.props.optimizeRouteResponse : null,
        routeOptimizationModalIsOpen: false
      })
    }
  }

  private onOptimizeTrip = async () => {
    console.log('Optimize Trip ', this.state.optimizeRouteResponse)

    this.setState({
      isOptimizeTripLoading: true
    })

    const response = await this.props.optimizeTrip({
      id: (this.state.optimizeRouteResponse && this.state.optimizeRouteResponse.id) || ''
    })

    this.setState({
      isOptimizeTripLoading: false,
      optimizeTripResponse: this.props.optimizeTripResponse
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/route-optimization/RouteOptimization.tsx